import { render, staticRenderFns } from "./SettingsTableWidget.vue?vue&type=template&id=6bfcfcf7&scoped=true"
import script from "./SettingsTableWidget.vue?vue&type=script&lang=js"
export * from "./SettingsTableWidget.vue?vue&type=script&lang=js"
import style0 from "./SettingsTableWidget.vue?vue&type=style&index=0&id=6bfcfcf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfcfcf7",
  null
  
)

export default component.exports